/* eslint-disable react/prop-types */

import { useEffect } from "react";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
// import QrCode from "qrcode.react";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import { Grid } from "@mui/material";
import QRCodeStyling from "qr-code-styling";
import brandMin from "assets/images/logo_min.png";
import pritchardLogo from "assets/images/pritchard-logo.png";

function PrintIcon({ id, location, subAccount, description }) {
  const handlePrint = useReactToPrint({
    content: () => document.getElementById(`qr-content-${id}`),
  });
  useEffect(() => {
    const qrCode = new QRCodeStyling({
      width: 512,
      height: 512,
      data: `${window.location.origin}/qr-code-clock-in/${id}`,
      image: brandMin,
      dotsOptions: {
        color: "#000",
        type: "rounded",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 20,
      },
    });
    document.getElementById(`qr-image-${id}`).innerHTML = "";
    qrCode.append(document.getElementById(`qr-image-${id}`));
  }, [id]);
  return (
    <span>
      <IconButton onClick={handlePrint} size="small" aria-label="close" color="inherit">
        <Icon fontSize="small">qr_code_2</Icon>
      </IconButton>
      <span style={{ display: "none" }}>
        <div
          id={`qr-content-${id}`}
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {/* <QrCode
            value={`${window.location.origin}/qr-code-clock-in/${id}`}
            size={512}
            includeMargin
            height="100%"
          /> */}
          <div style={{ marginTop: 20 }} />
          <MDBox component="img" src={pritchardLogo} alt="Pritchard" width="100%" />
          <div style={{ marginTop: 20 }} />
          <div id={`qr-image-${id}`} />
          <div style={{ marginTop: 40 }} />
          <Grid container justifyContent="space-around" style={{ marginBottom: "10%" }}>
            {/* <Grid item>
              <h2>Url</h2>
              <h4>{`${window.location.origin}/qr-code-clock-in/${id}`}</h4>
            </Grid> */}
            <Grid item>
              <h2>Location</h2>
              <h4>{location?.name}</h4>
            </Grid>
            <Grid item>
              <h2>Sub Account</h2>
              <h4>{subAccount}</h4>
            </Grid>
          </Grid>

          <Grid container justifyContent="space-around" style={{ marginBottom: "10%" }}>
            <Grid item>
              <h2>Description</h2>
              <h4>{description}</h4>
            </Grid>
          </Grid>
        </div>
      </span>
    </span>
  );
}

export default function tableConfig() {
  return {
    columns: [
      { Header: "Description", accessor: "description", align: "left" },
      { Header: "Location", accessor: "location", align: "center" },
      { Header: "Timezone", accessor: "timezone", align: "center" },
      { Header: "SubAccount", accessor: "project", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Created At", accessor: "createdAt", align: "center" },
      { Header: "Actions", accessor: "action", align: "center" },
    ],
    getRows: (data, locationData, timezoneData, setQrCodeToEdit) =>
      data.map((d) => ({
        description: d.description,
        location: locationData[d.location]?.name || "",
        timezone: timezoneData[d.timezone]?.text || "",
        project: d.project,
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={d.status === "1" ? "Active" : "Inactivte"}
              color={d.status === "1" ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        createdAt: d.createdAt ? moment(d.createdAt).locale("en").format("LLL") : "Never",
        action: (
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => setQrCodeToEdit(d)}
            >
              <Icon fontSize="small">edit</Icon>
            </IconButton>
            <PrintIcon
              id={d.id}
              location={locationData[d.location]}
              subAccount={d.project}
              description={d.description}
            />
          </>
        ),
      })),
  };
}
